import script from "./loadingMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./loadingMsg.vue?vue&type=script&setup=true&lang=js"

import "./loadingMsg.vue?vue&type=style&index=0&id=4465a60e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4465a60e"]])

export default __exports__